export function formatNumberWithCommas(sign, number) {
    return `${sign} ${number.toLocaleString('en-US')}`
}

export function formatNumberWithCommasAndDecimal(number, prefix = '') {
    // Преобразуем число в фиксированный десятичный формат с двумя знаками после запятой
    const fixedNumber = number.toFixed(2)

    // Разделяем результат на целую и десятичную часть
    let [integerPart, decimalPart] = fixedNumber.split('.')

    // Применяем форматирование с разделением тысяч к целой части
    integerPart = parseInt(integerPart).toLocaleString('en-US')

    // Возвращаем результат с добавлением десятичной части
    return `${prefix} ${integerPart}.${decimalPart}`

}